const frontendskills = [
    {
        title: 'Javascript',
        width: '90%',
        percentage: '90%'
    }, {
        title: 'Angular JS',
        width: '80%',
        percentage: '80%'
    }, {
        title: 'HTML',
        width: '95%',
        percentage: '95%'
    }, {
        title: 'CSS',
        width: '95%',
        percentage: '95%'
    }, {
        title: 'JAVA',
        width: '70%',
        percentage: '70%'
    },{
        title: 'C',
        width: '75%',
        percentage: '75%'
    }, {
        title: 'SQL',
        width: '60%',
        percentage: '60%'
    }, {
        title: 'DS',
        width: '70%',
        percentage: '70%'
    }, {
        title: 'OJET',
        width: '90%',
        percentage: '90%'
    },{
        title: 'Debugging',
        width: '90%',
        percentage: '90%'
    }, {
        title: 'SonarQube',
        width: '95%',
        percentage: '95%'
    }
]
export default frontendskills 